// extracted by mini-css-extract-plugin
export default {"startButton":"StartButton_startButton__3wuAj","arrowIcon":"StartButton_arrowIcon__Lef9I"};